export default "<div\n  ng-transclude\n  ng-if=\"vm.contentVisible\">\n</div>\n";